import { render } from "./AuthTemplate.vue?vue&type=template&id=1ba55cc2&scoped=true"
import script from "./AuthTemplate.vue?vue&type=script&lang=ts"
export * from "./AuthTemplate.vue?vue&type=script&lang=ts"

import "./AuthTemplate.vue?vue&type=style&index=0&id=1ba55cc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ba55cc2"

export default script